import React from 'react';
import Img from 'gatsby-image';
import { graphql } from 'gatsby';
import { uid } from 'react-uid';
import CheckSvg from '../../../assets/svg/icons/check.svg';
import SendGridLink from '../../SendGridLink';
import Code from '../../Code';
import Section from '../Section';
import {
  StyledMediaAndText,
  StyledHeader,
  StyledMedia,
  StyledContent,
  StyledCta,
} from './styles';

const UseCaseMediaAndText = ({ block }) => (
  <Section theme={block.theme}>
    <StyledMediaAndText layout={block.layout} hasCta={block.includeCta}>
      <StyledHeader>
        <h2 dangerouslySetInnerHTML={{ __html: block.title }} />
        {block.subtitle && (
          <p dangerouslySetInnerHTML={{ __html: block.subtitle }} />
        )}
      </StyledHeader>
      {block.media.map((media) => {
        const mediaType = media.fieldGroupName.split('_').pop();
        switch (mediaType) {
          case 'CodeExample':
            return (
              <StyledMedia mediaType={mediaType} key={uid(media)}>
                <Code language={media.language}>{media.code}</Code>
              </StyledMedia>
            );
          case 'Image':
            return (
              <StyledMedia key={uid(media)}>
                <Img
                  fluid={media.file.imageFile.childImageSharp.fluid}
                  alt={media.file.altText}
                />
              </StyledMedia>
            );
          default:
            return null;
        }
      })}
      <StyledContent>
        <p dangerouslySetInnerHTML={{ __html: block.copy }} />

        {block.listItems && (
          <ul>
            {block.listItems.map((item) => (
              <li key={uid(item)}>
                <figure>
                  <CheckSvg />
                </figure>
                <div dangerouslySetInnerHTML={{ __html: item.copy }} />
              </li>
            ))}
          </ul>
        )}
      </StyledContent>
      {block.includeCta && (
        <StyledCta>
          <SendGridLink
            to={block.ctaUrl}
            className="arrow-link"
            dangerouslySetInnerHTML={{ __html: block.ctaText }}
          />
        </StyledCta>
      )}
    </StyledMediaAndText>
  </Section>
);

export default UseCaseMediaAndText;

export const query = graphql`
  fragment UseCaseMediaAndTextFragment on WPGraphQL_UseCase {
    acfUseCases {
      contentBlocks {
        ... on WPGraphQL_UseCase_Acfusecases_ContentBlocks_MediaAndText {
          fieldGroupName
          theme
          layout
          title
          subtitle
          copy
          includeCta
          ctaText
          ctaUrl
          listItems {
            copy
          }
          media {
            ... on WPGraphQL_UseCase_Acfusecases_ContentBlocks_MediaAndText_Media_Image {
              fieldGroupName
              file {
                sourceUrl
                altText
                imageFile {
                  childImageSharp {
                    fluid(maxWidth: 460) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
            ... on WPGraphQL_UseCase_Acfusecases_ContentBlocks_MediaAndText_Media_CodeExample {
              fieldGroupName
              language
              code
            }
          }
        }
      }
    }
  }
`;
